module.exports = {
  shortcuts : {
    save: [
      { key: 'shift', keyCode: 16 },
      { key: 's', keyCode: 83 }
    ],
    run: [
      { key: 'shift', keyCode: 16 },
      { key: 'r', keyCode: 82 }
    ],
    back_to_query_list: [
      { key: 'shift', keyCode: 16 },
      { key: 'escape', keyCode: 27 }
    ]
  }
};